import { render, staticRenderFns } from "./waterPaid.vue?vue&type=template&id=47d48aef&"
import script from "./waterPaid.vue?vue&type=script&lang=js&"
export * from "./waterPaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports